// Domain-based branding.
//   restaurant.goerp.live / restaurent.goerp.live / *dine*  → DineMaster (222.png)
//   hotel.goerp.live / anything else                        → Hotel Desk (LOGO 12 / hoteldesk.png)
// On the login page the property type isn't known yet, so the HOST decides.
// Elsewhere we also honour a restaurant-only property (propertType === 'R').
export function getBrand() {
  let host = '';
  try {
    host = (window.location.hostname || '').toLowerCase();
  } catch {
    host = '';
  }

  // propertType is the AUTHORITY when known (post-login). The separate
  // `propertType` sessionStorage key is never reliably set, so read it from the
  // stored `companyDetails` object (the GetCompanyDetails response, which has
  // it). Host only decides on the login page, where the type isn't known yet.
  let propertType = null;
  try {
    propertType = sessionStorage.getItem('propertType');
    if (!propertType) {
      const cd = JSON.parse(sessionStorage.getItem('companyDetails') || '{}');
      propertType = cd?.propertType || null;
    }
  } catch {
    propertType = null;
  }

  const isRestaurant = propertType
    ? propertType === 'R'
    : host.includes('restaurant') ||
      host.includes('restaurent') ||
      host.includes('resto') ||
      host.includes('dine');

  return isRestaurant
    ? {
        isRestaurant: true,
        name: 'Dine In Master',
        sub: 'Restro Management',
        logo: '/restaurant-logo.png',
      }
    : {
        isRestaurant: false,
        name: 'Hotel Desk',
        sub: 'Hotel Management',
        logo: '/hoteldesk.png',
      };
}
